import React from 'react';
import { motion } from 'framer-motion';
import { XCircle, CheckCircle } from 'lucide-react';
import { OrderBumpSection } from './OrderBumpSection';
import { CtaSection } from './CtaSection';
export function ClosingSection() {
  return <section className="py-24 px-4 border-t border-white/5" style={{
    backgroundColor: '#080808'
  }} data-id="element-15">
      <div className="max-w-5xl mx-auto text-center" data-id="element-16">
        <h2 className="text-3xl md:text-5xl font-bold text-white mb-16" data-id="element-17">
          You have two options today:
        </h2>

        <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-18">
          {/* Option 1: Negative */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="bg-[#0a0a0f] border border-red-900/30 p-8 rounded-2xl opacity-75 hover:opacity-100 transition-opacity" data-id="element-19">
            <XCircle className="w-12 h-12 text-red-500 mx-auto mb-6 opacity-50" data-id="element-20" />
            <h3 className="text-xl font-bold text-gray-400 mb-4" data-id="element-21">
              Keep doing what you're doing
            </h3>
            <p className="text-gray-500 leading-relaxed" data-id="element-22">
              Let the banks charge you 25% interest, get rejected for loans, and
              watch your financial future stall.
            </p>
          </motion.div>

          {/* Option 2: Positive */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="bg-gradient-to-b from-[#1a1a24] to-[#0d0d14] border-2 border-gold p-8 rounded-2xl shadow-gold-glow transform md:-translate-y-4" data-id="element-23">
            <CheckCircle className="w-12 h-12 text-gold mx-auto mb-6" data-id="element-24" />
            <h3 className="text-2xl font-bold text-white mb-4" data-id="element-25">
              Become a Credit Hacker
            </h3>
            <p className="text-gray-300 leading-relaxed text-lg" data-id="element-26">
              Take control of your report, skyrocket your score to 750+, and
              start using the bank's money to build YOUR wealth.
            </p>
          </motion.div>
        </div>

        {/* Order Bump — directly above the final CTA */}
        <div className="mb-10" data-id="element-27">
          <OrderBumpSection embedded data-id="element-28" />
        </div>

        <div id="checkout" className="max-w-2xl mx-auto scroll-mt-24" data-id="element-29">
          <CtaSection showTrustBadges={true} isCheckout={true} data-id="element-30" />
        </div>
      </div>
    </section>;
}